import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-lg-5 col-xl-12" }
const _hoisted_3 = { class: "col-xxl-12" }
const _hoisted_4 = { class: "card mb-25 border-0 rounded-0 bg-white checkout-box letter-spacing" }
const _hoisted_5 = { class: "card-body" }
const _hoisted_6 = {
  class: "nav nav-tabs bg-white border-0 rounded-0",
  id: "myTab",
  role: "tablist"
}
const _hoisted_7 = {
  class: "nav-item",
  role: "presentation"
}
const _hoisted_8 = {
  class: "nav-link fs-14 fs-md-15 fs-lg-16 fw-semibold position-relative border-0 rounded-0 d-block w-100 active",
  id: "shipping-details-tab",
  "data-bs-toggle": "tab",
  "data-bs-target": "#shipping-details-tab-pane",
  type: "button",
  role: "tab",
  "aria-controls": "shipping-details-tab-pane",
  "aria-selected": "true",
  ref: "tabStudent"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-student-with-graduation-cap" }, null, -1)
const _hoisted_10 = {
  class: "nav-item",
  role: "presentation"
}
const _hoisted_11 = {
  class: "nav-link fs-14 fs-md-15 fs-lg-16 fw-semibold position-relative border-0 rounded-0 d-block w-100",
  id: "payment-method-tab",
  "data-bs-toggle": "tab",
  "data-bs-target": "#payment-method-tab-pane",
  type: "button",
  role: "tab",
  "aria-controls": "payment-method-tab-pane",
  "aria-selected": "false",
  ref: "tabPayment"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-draft" }, null, -1)
const _hoisted_13 = {
  class: "nav-item",
  role: "presentation"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-credit-card" }, null, -1)
const _hoisted_15 = {
  class: "nav-item",
  role: "presentation"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-folder-1" }, null, -1)
const _hoisted_17 = {
  class: "tab-content p-15 p-sm-20 p-md-25 p-lg-30",
  id: "myTabContent"
}
const _hoisted_18 = {
  class: "tab-pane fade show active",
  id: "shipping-details-tab-pane",
  role: "tabpanel",
  tabindex: "0"
}
const _hoisted_19 = /*#__PURE__*/_createElementVNode("label", {
  for: "inputRep",
  class: "form-label fw-medium text-black"
}, "Estudiante", -1)
const _hoisted_20 = { class: "row" }
const _hoisted_21 = { class: "col-md-12" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("label", {
  for: "inputRep",
  class: "form-label fw-medium text-black"
}, "Año académico", -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("label", {
  for: "inputRep",
  class: "form-label fw-medium text-black"
}, "Sede", -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("label", {
  for: "inputRep",
  class: "form-label fw-medium text-black"
}, "Grupo asignado", -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("label", {
  for: "inputRep",
  class: "form-label fw-medium text-black"
}, "Fecha registro de admisión", -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("label", {
  for: "inputRep",
  class: "form-label fw-medium text-black"
}, "Lista de precio", -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("label", {
  for: "inputRep",
  class: "form-label fw-medium text-black"
}, "Descuento", -1)
const _hoisted_28 = {
  class: "tab-pane fade",
  id: "payment-method-tab-pane",
  role: "tabpanel",
  tabindex: "0"
}
const _hoisted_29 = {
  class: "tab-pane fade",
  id: "payments-tab-pane",
  role: "tabpanel",
  tabindex: "0"
}
const _hoisted_30 = {
  class: "tab-pane fade",
  id: "discounts-tab-pane",
  role: "tabpanel",
  tabindex: "0"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BreadCrumb = _resolveComponent("BreadCrumb")!
  const _component_b_button = _resolveComponent("b-button")!
  const _component_SearchSelect = _resolveComponent("SearchSelect")!
  const _component_b_form_group = _resolveComponent("b-form-group")!
  const _component_b_col = _resolveComponent("b-col")!
  const _component_b_row = _resolveComponent("b-row")!
  const _component_b_form_input = _resolveComponent("b-form-input")!
  const _component_b_form_invalid_feedback = _resolveComponent("b-form-invalid-feedback")!
  const _component_EnrollmentChargeContent = _resolveComponent("EnrollmentChargeContent")!
  const _component_PaymentsContent = _resolveComponent("PaymentsContent")!
  const _component_EnrollmentAppliedDiscounts = _resolveComponent("EnrollmentAppliedDiscounts")!
  const _component_b_form = _resolveComponent("b-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_BreadCrumb, {
        PageTitle: _ctx.form.record.Id > 0 ? `Cuenta de ${_ctx.studentRecord?.Name || ''} ${_ctx.studentRecord?.LastName || ''}` : ''
      }, null, 8, ["PageTitle"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("ul", _hoisted_6, [
            _createElementVNode("li", _hoisted_7, [
              _createElementVNode("button", _hoisted_8, [
                _hoisted_9,
                _createTextVNode(" DATOS ESTUDIANTE ")
              ], 512)
            ]),
            _createElementVNode("li", _hoisted_10, [
              _createElementVNode("button", _hoisted_11, [
                _hoisted_12,
                _createTextVNode(" CARGOS DE INSCRIPCIÓN ")
              ], 512)
            ]),
            _createElementVNode("li", _hoisted_13, [
              _createVNode(_component_b_button, {
                class: "nav-link fs-14 fs-md-15 fs-lg-16 fw-semibold position-relative border-0 rounded-0 d-block w-100",
                id: "payments-tab-tab",
                "data-bs-toggle": "tab",
                "data-bs-target": "#payments-tab-pane",
                type: "button",
                role: "tab",
                "aria-controls": "payments-tab-pane",
                "aria-selected": "false",
                ref: "tabConfirm"
              }, {
                default: _withCtx(() => [
                  _hoisted_14,
                  _createTextVNode(" PAGOS ")
                ]),
                _: 1
              }, 512)
            ]),
            _createElementVNode("li", _hoisted_15, [
              _createVNode(_component_b_button, {
                class: "nav-link fs-14 fs-md-15 fs-lg-16 fw-semibold position-relative border-0 rounded-0 d-block w-100",
                id: "discounts-tab",
                "data-bs-toggle": "tab",
                "data-bs-target": "#discounts-tab-pane",
                type: "button",
                role: "tab",
                "aria-controls": "discounts-tab-pane",
                "aria-selected": "false",
                ref: "tabConfirm"
              }, {
                default: _withCtx(() => [
                  _hoisted_16,
                  _createTextVNode(" DESCUENTOS APLICADOS ")
                ]),
                _: 1
              }, 512)
            ])
          ]),
          _createVNode(_component_b_form, {
            ref: "formRecord",
            id: "formModal",
            onSubmit: _withModifiers(_ctx.handleSubmit, ["prevent"])
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  _createVNode(_component_b_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_b_col, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_b_form_group, null, {
                            default: _withCtx(() => [
                              _hoisted_19,
                              _createElementVNode("div", _hoisted_20, [
                                _createElementVNode("div", _hoisted_21, [
                                  _createVNode(_component_SearchSelect, {
                                    modelValue: _ctx.form.record.StudentId,
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.record.StudentId) = $event)),
                                    required: "",
                                    "was-validated": _ctx.form.wasValidated,
                                    onChange: _ctx.changeValuesLoad,
                                    disabled: _ctx.disabledRecord,
                                    loading: _ctx.form.loading,
                                    options: _ctx.students.map(r => ({ value: r.Id, text: `${r.IdentificationNumber} - ${r.Name} ${r.LastName}` })),
                                    placeholder: "Seleccione el estudiante"
                                  }, null, 8, ["modelValue", "was-validated", "onChange", "disabled", "loading", "options"])
                                ])
                              ])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_b_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_b_col, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_b_form_group, null, {
                            default: _withCtx(() => [
                              _hoisted_22,
                              _createVNode(_component_SearchSelect, {
                                modelValue: _ctx.form.record.AcademicYearId,
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.record.AcademicYearId) = $event)),
                                required: "",
                                "was-validated": _ctx.form.wasValidated,
                                loading: _ctx.form.loading,
                                disabled: _ctx.disabledRecord,
                                options: _ctx.academicYears.map(r => ({ value: r.Id, text: `Año ${r.Year} - Período: ${r.StartDate.substring(0, 10)} Hasta ${r.EndDate.substring(0, 10)}` })),
                                placeholder: "Seleccione el año académico",
                                onChange: _ctx.changeValuesLoad
                              }, null, 8, ["modelValue", "was-validated", "loading", "disabled", "options", "onChange"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_b_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_b_col, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_b_form_group, null, {
                            default: _withCtx(() => [
                              _hoisted_23,
                              _createVNode(_component_SearchSelect, {
                                modelValue: _ctx.form.record.HeadquarterId,
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.record.HeadquarterId) = $event)),
                                required: "",
                                "was-validated": _ctx.form.wasValidated,
                                loading: _ctx.form.loading,
                                disabled: _ctx.disabledRecord,
                                options: _ctx.headquarters.map(r => ({ value: r.Id, text: `${r.Description}` })),
                                placeholder: "Seleccione la sede",
                                onChange: _ctx.changeValuesLoad
                              }, null, 8, ["modelValue", "was-validated", "loading", "disabled", "options", "onChange"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_b_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_b_col, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_b_form_group, null, {
                            default: _withCtx(() => [
                              _hoisted_24,
                              _createVNode(_component_SearchSelect, {
                                modelValue: _ctx.form.record.CourseGroupId,
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.record.CourseGroupId) = $event)),
                                required: "",
                                "was-validated": _ctx.form.wasValidated,
                                loading: _ctx.form.loading,
                                disabled: _ctx.disabledRecord,
                                options: _ctx.coursesGroupAvailable.map(r => ({ value: r.Id, text: r.Name })),
                                placeholder: "Seleccione el grupo"
                              }, null, 8, ["modelValue", "was-validated", "loading", "disabled", "options"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_b_col, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_b_form_group, null, {
                            default: _withCtx(() => [
                              _hoisted_25,
                              _createVNode(_component_b_form_input, {
                                id: "input-enrollment-date",
                                disabled: _ctx.disabledRecord,
                                class: "form-control fs-14 text-black shadow-none form-control-sm",
                                modelValue: _ctx.form.record.EnrollmentDate,
                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.record.EnrollmentDate) = $event)),
                                type: "date",
                                required: ""
                              }, null, 8, ["disabled", "modelValue"]),
                              _createVNode(_component_b_form_invalid_feedback, null, {
                                default: _withCtx(() => [
                                  _createTextVNode("Campo requerido")
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_b_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_b_col, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_b_form_group, null, {
                            default: _withCtx(() => [
                              _hoisted_26,
                              _createVNode(_component_SearchSelect, {
                                modelValue: _ctx.form.record.TuitionPriceLineId,
                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.record.TuitionPriceLineId) = $event)),
                                required: "",
                                "was-validated": _ctx.form.wasValidated,
                                loading: _ctx.form.loading,
                                disabled: _ctx.disabledRecord,
                                options: _ctx.priceLineFiltered.map(r => ({ value: r.Id, text: `${_ctx.getPriceListById(r.PriceListId)?.Name || ''} - ${r.Concept || ''} - $ ${r.Amount || '0.00'} ${_ctx.priceListRecord.Currency || ''}` })),
                                placeholder: "Seleccione el valor de la lista",
                                onChange: _ctx.changeValuesLoad
                              }, null, 8, ["modelValue", "was-validated", "loading", "disabled", "options", "onChange"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_b_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_b_col, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_b_form_group, null, {
                            default: _withCtx(() => [
                              _hoisted_27,
                              _createVNode(_component_SearchSelect, {
                                modelValue: _ctx.form.record.DiscountId,
                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.record.DiscountId) = $event)),
                                "was-validated": _ctx.form.wasValidated,
                                loading: _ctx.form.loading,
                                disabled: _ctx.disabledRecord,
                                options: _ctx.discounts.map(r => ({ value: r.Id, text: `${r.Description}` })),
                                placeholder: "Seleccione el descuento (Si aplica)",
                                onChange: _ctx.changeValuesLoad
                              }, null, 8, ["modelValue", "was-validated", "loading", "disabled", "options", "onChange"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_28, [
                  (_ctx.form.record?.Id)
                    ? (_openBlock(), _createBlock(_component_EnrollmentChargeContent, {
                        key: 0,
                        record: _ctx.form.record
                      }, null, 8, ["record"]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_29, [
                  (_ctx.form.record?.Id)
                    ? (_openBlock(), _createBlock(_component_PaymentsContent, {
                        key: 0,
                        record: _ctx.form.record
                      }, null, 8, ["record"]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_30, [
                  (_ctx.form.record?.Id)
                    ? (_openBlock(), _createBlock(_component_EnrollmentAppliedDiscounts, {
                        key: 0,
                        record: _ctx.form.record
                      }, null, 8, ["record"]))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            _: 1
          }, 8, ["onSubmit"])
        ])
      ])
    ])
  ]))
}